import apiClient, { ApiMessage } from "./client";

/** 登录用户信息（data 字段） */
export interface LoginUserData {
  frontflag: number; // 1=前端用户, 0=后端用户
  organizeid: string;
  loginname: string;
  name: string;
  id: string;
}

/** 登录接口响应 */
export interface LoginResponse {
  success: boolean;
  info: string;
  /** 用户 ID */
  userId?: string;
  /** token（memo 字段） */
  token?: string;
  /** 用户信息 */
  user?: LoginUserData;
}

/** 执行登录 */
export async function login(
  loginname: string,
  password: string,
  securitycode?: string
): Promise<LoginResponse> {
  const params = new URLSearchParams();
  params.append("loginname", loginname);
  params.append("password", password);
  if (securitycode) {
    params.append("securitycode", securitycode);
  }

  const response = await apiClient.post<ApiMessage & { data?: LoginUserData }>(
    "/agent/login.do",
    params.toString()
  );

  const body = response.data;
  return {
    success: body.success,
    info: body.info,
    userId: body.id,
    token: body.memo,
    user: body.data,
  };
}
